import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Member_projectg_time() {
    const active_pro_name = localStorage.getItem('selected_project_name');
    const [listProjecttimeArray, setListProjecttimeArray] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [totalTime, setTotalTime] = useState(0);
    const [membretype, setMembertype] = useState(false);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
        setPermissions(storedPermissions);
        const active_pro_id = localStorage.getItem('selected_project_id');
        const memid = localStorage.getItem('member_id');

        fetch('getMemberProjectTime.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                pro_id: active_pro_id,
                memberid: memid
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);

                if (Array.isArray(data) && data.length > 0) {
                    setListProjecttimeArray(data);
                } else {
                    showAlert('Cannot find any Time record for this project.');
                    setListProjecttimeArray([]);
                }
            })
            .catch(err => {
                console.error("Fetch Error:", err);
            });

    }, [])

    useEffect(() => {
        let totalSeconds = 0;

        listProjecttimeArray.forEach(item => {
            totalSeconds += timeToSeconds(item.time_worked);
        });
        console.log('totalSeconds : ' + totalSeconds)
        setTotalTime(totalSeconds);
    }, [listProjecttimeArray]);

    const timeToSeconds = (timeStr) => {
        if (!timeStr) return 0;

        const parts = timeStr.split(':');
        const h = parseInt(parts[0]) || 0;
        const m = parseInt(parts[1]) || 0;
        const s = parseInt(parts[2]) || 0;
        console.log(h + ' : ' + m + ' : ' + s)
        return (h * 3600) + (m * 60) + s;
    };

    const formatTotalTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);

        return `${hrs}h ${mins}m`;
    };

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }


    function viewTaskDetails(details) {
        document.getElementById('taskdetails').style.display = 'block';
        document.getElementById('task_text').textContent = details;
    }

    function closeTskdetails() {
        document.getElementById('taskdetails').style.display = 'none';
        document.getElementById('task_text').textContent = '';
    }


    return (
        <div>
            <div className='topbar_menu'>

                <p>Project name : {active_pro_name}</p>
                <p>Total time Worked : <span>{formatTotalTime(totalTime)}</span></p>
            </div>
            <div className='member_row'>
                <div className='member_details'>
                    <section className='vl_dsh_bodypart_section pos_rel'>
                        <div id="timeSheetArea">
                            <div className='vl_listing_area'>
                                <div className='vl_listing_row'>

                                    <div className='vl_listing_cell width25'>
                                        <p>Task Name</p>
                                    </div>

                                    <div className='vl_listing_cell width15'>
                                        <p>Start time</p>
                                    </div>
                                    <div className='vl_listing_cell width15'>
                                        <p>End time</p>
                                    </div>
                                    <div className='vl_listing_cell width15'>
                                        <p>Time Worked</p>
                                    </div>
                                </div>
                                {Array.isArray(listProjecttimeArray) && listProjecttimeArray.map((item, index) => {

                                    return (
                                        <div className='vl_listing_row'>
                                            <div className='vl_listing_cell width25' key={index}>
                                                <h4 className='prj_name'>{item.task_name}</h4>
                                                <span>Date : {item.dateofWork}</span>
                                                <span><button className='startbutton' onClick={() => viewTaskDetails(item.task_details)}>View Task Details</button></span>
                                            </div>

                                            <div className='vl_listing_cell width15'>
                                                <p>{item.start_time}</p>
                                            </div>
                                            <div className='vl_listing_cell width15'>
                                                <p>{item.end_time ? item.end_time : 'Running...'}</p>
                                            </div>
                                            <div className='vl_listing_cell width15'>
                                                <p>{item.time_worked}</p>
                                            </div>

                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

            <div className='vl_dsh_popup' id="taskdetails">
                <div className='alertbox bigheight'>

                    <div className='contentarea'>
                        <p id="task_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeTskdetails}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>


                    </div>
                </div>
            )}
        </div>
    )
}
